<select (ngModelChange)="valueChanged($event)" [ngModel]="selectedIndex" [disabled]="isDisabled">
  <option hidden>{{ placeholder }}</option>
  <option *ngFor="let item of options" [value]="item.id">
    {{ item.description }}
  </option>
</select>
